module.exports = __webpack_public_path__ + "img/download-linkedin-profile-pdf-fr.abab3249.png";